
import { defineComponent } from "vue";

interface Props {
  isUsed: string;
}

export default defineComponent({
  name: "SticksCard",

  props: {
    id: { type: Number, required: true },
    name: { type: String, required: true },
    file: { type: String, required: true },
    stats: { type: Object, required: true },
    isUsed: { type: Boolean, default: false },
  },

  computed: {
    buttonText: ({ isUsed }: Props) => (isUsed ? 'Using' : 'Use'),
  },
});
